$.fn.select2nonUnique = function(...args) {
  this.each(function(index) {
    const domId = $(this).prop('id');

    if (domId) {
      $(this).attr('data-select2-id', `${domId}${index}${Math.random()}`);
    }
  });

  this.select2(...args);
};

if (toastrMessages) {
  Object.keys(toastrMessages).forEach((type) => {
    const errors = toastrMessages[type];

    errors.forEach((message) => {
      if (type in toastr) {
        toastr[type](message);
      }
    });
  });
}
